module.exports = __webpack_public_path__ + "static/media/flexible-payment-card.3ac23635.jpg";